// removed by extract-text-webpack-plugin
module.exports = {"otModalForm":"style__otModalForm__39OdF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalForm/style.less
// module id = 1299
// module chunks = 0